import DataResume from "@/services/DataResume";
import { Resume } from "@/types";
// import UserLogin from "@/utility/User";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";
// import { userModule } from "./user";

export interface ResumeState {
  resume: Resume[];
}

export interface Discharge {
  id: number;
  label: string;
  value: string;
  nama: string;
}

@Module({ store, dynamic: true, namespaced: true, name: "storeResume" })
class ResumeStore extends VuexModule implements ResumeState {
  resume: Resume[] = [];
  listDischarge: Discharge[] = [];
  loading = false;
  registerId: string | number | null = null;

  @Mutation SET_RESUME(resume: Resume[]) {
    this.resume = resume;
  }

  @Mutation SET_REGISTER_ID(registerId: string | number | null) {
    this.registerId = registerId;
  }

  @Mutation SET_LIST_DISCHARGE(list: Discharge[]) {
    this.listDischarge = list;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async act_resume_on_reg(param: any) {
    const reg =
      typeof param === "object" && param !== null ? param["reg"] : param;

    if (String(this.registerId) !== String(reg)) {
      this.SET_RESUME([]);
    }

    this.SET_REGISTER_ID(reg);
    this.SET_LOADING(true);

    const idUser = "";

    try {
      const dt = await DataResume.getDataResume(reg, idUser);

      if (String(this.registerId) !== String(reg)) return;

      if (dt && Array.isArray(dt.data)) {
        this.SET_RESUME(dt.data);
      }
    } catch (e) {
      //
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action act_on_discharge(term: string) {
    appModule.setLoading(true);

    const dt = DataResume.getDataDischarge(term);
    dt.then(dt => {
      appModule.setLoading(false);
      const ls = dt;
      // console.log('d', ls)
      this.SET_LIST_DISCHARGE(ls);
    });
  }
  @Action clearResume() {
    this.SET_RESUME([]);
    this.SET_REGISTER_ID(null);
  }
}

export const storeResume = getModule(ResumeStore);
